import { render } from "./VideoWallPageSidebar.vue?vue&type=template&id=8c1b8236&ts=true"
import script from "./VideoWallPageSidebar.vue?vue&type=script&lang=ts"
export * from "./VideoWallPageSidebar.vue?vue&type=script&lang=ts"

import "./VideoWallPageSidebar.vue?vue&type=style&index=0&id=8c1b8236&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__